module.exports = __webpack_public_path__ + "img/s-7.273ee4fc.png";